import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import reservationStore from "../store/reservationStore";
import api from "../utils/api";

import Bottom from "./Bottom";
import HomeTop from "../components/HomeTop";
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import * as util from "../utils/util";
import { goLoginAndReturn } from "../utils/loginRedirect";
import Skeleton from '@mui/material/Skeleton';
import careStore from "../store/careStore";
import ButtonBase from '@mui/material/ButtonBase';
import reimg1 from "../assets/images/reimg1.png";
import reimg2 from "../assets/images/reimg2.png";
import reimg3 from "../assets/images/reimg3.png";
import { styled } from '@mui/material/styles';
import MainCounsel from "../components/main/MainCounsel";
import * as React from "react";

import counsel from '../assets/main/counsel.png';


const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});




// 새로고침 이미지 변경
const ImgArr = [reimg1, reimg3,];
const randomIndex = Math.floor(Math.random() * ImgArr.length);
const reTopImg = ImgArr[randomIndex];



const Reservation = () => {
  const [loading, setLoading] = useState(false);
  // 조회 실패 상태. 예전에는 catch 가 console.log 뿐이라 loading 이 true 로 굳어
  // 스켈레톤만 남거나(목록이 비어) 아무것도 보이지 않았고, 다시 시도할 방법도 없었다.
  const [failed, setFailed] = useState(false);
  const [reloadNonce, setReloadNonce] = useState(0);
  const storeData: any = reservationStore();
  const [reservationPersons, setReservationPersons] = useState([]); // 예약 대상 인원
  const navigate = useNavigate();
  const storeData1: any = careStore();

  useEffect(() => {

    return () => {
      storeData1.setCareInfo('height', 0);
      storeData1.setCareInfo('weight', 0);
      storeData1.setCareInfo('reset', '');
    }
  }, []);

  useEffect(() => {
    // 비로그인이면 조회할 것이 없다 — 로딩 상태로 두면 스켈레톤이 남는다
    if (util.strNull(window.localStorage.userCusID) === '') {
      setLoading(false);
      return;
    }

    setLoading(true);
    setFailed(false);
    // 예약 대상 인원 목록
    api.post('customer/api/v1/CU_003_001', { cusId: window.localStorage.userCusID }).then((res: any) => {
      setReservationPersons(res.data);
    }).catch(function (error: any) {
      console.log(error);
      setFailed(true);
    }).finally(function () {
      // 실패해도 로딩 표시는 반드시 걷는다
      setLoading(false);
    });
  }, [reloadNonce]);

  // 예약하기
  async function doReservation(person: any) {

    if(person['phone'] == '휴대전화번호입력') {
      alert('휴대전화번호를 입력해주세요.');
      navigate('/MyPage/MyPage');
      return;
    }

    // B2B + 웹/앱 가입 + 가족관계 미입력 고객
    if(person['companyType'] == 'B2B' && person['familyInfo'] == null  && ( person['customerId'].includes('CU') || person['customerId'].includes('nice') ) ) {
      alert('가족관계를 입력해주세요.');
      navigate('/MyPage/MyPage');
      return;
    }

    try {
      const companyInfo = await getCompanyInfo(person['famId']);
      localStorage.setItem('FAM_INFO', JSON.stringify(person));
      localStorage.setItem('companyInfo', JSON.stringify(companyInfo));
      storeData.setReservationInfo('famId', person['famId']);
      storeData.setReservationInfo('companyId', person['companyId']);
      // const check = true;
      // 직스 스트레스 참여 여부와 관계 없이 진행
      const check = await checkStressSurveyStatus(companyInfo, reservationPersons.filter(item => item['grade'] === '본인')[0]['famName']);
      if (check) navigate('/reservation/ReservationStep');
    } catch (e) {
      throw e;
    }
  }

  // 예약하기 대상 인원 회사 정보
  async function getCompanyInfo(famId: string) {
    let companyInfo = {};
    await api.get('customer/api/v2/families/' + encodeURIComponent(famId) + '/companies').then((res: any) => {
      companyInfo = res.data.data;
    }).catch(function (error: any) {
      console.log(error)
    });
    return companyInfo;
  }

  // 직무 스트레스 조사 여부 확인
  function checkStressSurveyStatus(com: any, famName: string) {
    if (com['is_survey']) {
      if (!com['is_owner_has_stress_survey']) {
        if (com['is_owner']) {
          alert(famName + '(본인) 회원님의\n직무 스트레스 조사가 완료된 후에\n예약 진행이 가능합니다.');
          navigate('/survey/stress');
          return false;
          // if (window.confirm(famName + "(본인) 회원님의\n직무 스트레스 조사가 완료된 후에\n예약 진행이 가능합니다.")) {
          //   navigate('/stress')
          //   return false;
          // }
        } else {
          alert(famName + '(본인) 회원님의\n직무 스트레스 조사가 완료된 후에\n예약 진행이 가능합니다.');
          return false;
        }
      }
    }
    return true;
  }



  return (


    <Container sx={{ p: { xs: 0, md: 0 }, bgcolor: '#F6F6F6', pb: '60px !important', minHeight: '100vh', minWidth: 320 }}>
      <Box sx={{ bgcolor: '#FFEADF', borderRadius: '0 0 40px 40px', display: 'flex', p: 0, minWidth: 320 }} >
        {/* logo */}
        <Box position={'fixed'} width={'100%'} bgcolor={'#ffeadf'} zIndex={999} maxWidth={'1200px'} >
          <Stack direction={'row'} >
            <Box>
              <ButtonBase sx={{ width: 180, height: 50, ml: 1 }}>
                <Img alt="Dual" src="/dual.png" />
              </ButtonBase>
            </Box>
          </Stack>
        </Box>

        <Grid container spacing={2} direction='row' sx={{ mt: 6, }}>
          <Grid item container xs sx={{ pl: 2 }} direction='column' justifyContent='center' alignContent={'center'}>
            <Typography className='topText' sx={{ fontSize: '2.2rem', color: '#FF7863', fontWeight: 900, }}>
              건강검진
            </Typography>
            <Typography sx={{ fontSize: '1.8rem', color: '#EF8322', fontWeight: 500, }} gutterBottom>
              예약서비스
            </Typography>
          </Grid>
          <Grid sx={{ width: '45%', mr: 1, pt: 0, pl: 0 }} alignContent={'center'} justifyContent='center'>
            <Img alt="reservation" src={reTopImg} />
          </Grid>
        </Grid>
      </Box>

      <Grid item>
        <Typography sx={{ display: 'block', fontSize: '16px', color: '#444', p: '30px 0 0 0', textAlign: 'center' }}>
          <b>원하시는 검진 프로그램</b>을 <br /><b>편리하게 예약</b>하실 수 있습니다.
        </Typography>
      </Grid>

      {util.strNull(window.localStorage.userCusID) === '' ? (



        <Grid item sx={{ mt: 10 }}>
          <Box sx={BtnStyle}>
            <Button variant="contained" sx={BottomBtnStyle}
              onClick={() => goLoginAndReturn(navigate, '/reservation')}
            >
              로그인 후 이용해주세요.
            </Button>
          </Box>



        </Grid>
      ) : failed ? (
        // 조용히 빈 화면으로 두지 않는다 — 무슨 일인지 알리고 다시 시도할 길을 준다
        <Grid item sx={{ mt: 8 }}>
          <Stack alignItems={'center'} spacing={1}>
            <Typography sx={{ fontSize: 15, color: '#888' }}>예약 정보를 불러오지 못했습니다.</Typography>
            <Button onClick={() => setReloadNonce((n) => n + 1)} sx={{ color: '#EF8322', fontSize: 15, fontWeight: 700 }}>
              다시 시도
            </Button>
          </Stack>
        </Grid>
      ) : (
        reservationPersons && reservationPersons.map((person, index) => (
          <Grid key={index} item sx={{ m: 3, }}>
            <Card variant="outlined" sx={{ borderRadius: 5 }}>
              <Box sx={{ p: 2 }}>
                {loading ? (
                  <Stack direction={'column'} sx={{ display: loading ? 'flex' : 'none', }} justifyContent='center' alignItems={'center'} alignContent={'center'}>
                    <Skeleton animation="wave" variant="rounded" height={24} width='80%' sx={{ borderRadius: 3, }} />
                  </Stack>
                ) : (
                  <Stack justifyContent="space-between" alignItems="center">
                    <Typography component="div" sx={{ fontSize: 16, fontWeight: 700, color: '#777', }}>
                      예약자 정보 ({person['grade']})
                    </Typography>
                  </Stack>
                )}
              </Box>
              <Divider variant="middle" />
              <Box sx={{}}>
                {loading ? (
                  <Stack direction={'column'} sx={{ display: loading ? 'flex' : 'none', }} justifyContent='center' alignItems={'center'} alignContent={'center'}>
                    <Skeleton animation="wave" variant="rounded" height={22} width='80%' sx={{ borderRadius: 3, my: 2, }} />
                    <Skeleton animation="wave" variant="rounded" height={22} width='80%' sx={{ borderRadius: 3, my: 2 }} />
                    <Skeleton animation="wave" variant="rounded" height={22} width='80%' sx={{ borderRadius: 3, my: 2, }} />
                    <Skeleton animation="wave" variant="rounded" height={22} width='80%' sx={{ borderRadius: 3, my: 2 }} />

                  </Stack>
                ) : (
                  <Stack direction="row" spacing={1}>
                    <List sx={{ width: '35%', pl: 1 }}>
                      <ListItem sx={{ pt: '12px', pb: '11px', pl: 1, pr: 1 }}>
                        성명
                      </ListItem>
                      <ListItem sx={{ pl: 1, pr: 1 }}>
                        생년월일
                      </ListItem>
                      <ListItem sx={{ pl: 1, pr: 1 }}>
                        연락처
                      </ListItem>
                      <ListItem sx={{ pl: 1, pr: 1 }}>
                        주소
                      </ListItem>
                    </List>
                    <List sx={{ width: '65%', }}>
                      <ListItem sx={{ pl: 0, pb: '11px', fontWeight: 700, color: '#4A3B96', fontSize: 18 }}>
                        {person['famName']}
                      </ListItem>
                      <ListItem sx={{ pl: 0, fontWeight: 500, }}>
                        {person['birthDate']}
                      </ListItem>
                      <ListItem sx={{ pl: 0, fontWeight: 500, }}>
                        {person['phone']}
                      </ListItem>
                      <ListItem sx={{ pl: 0, fontWeight: 500, lineHeight: '180%' }}>
                        {person['address'] + ', ' + person['buildingNum']}
                      </ListItem>
                    </List>
                  </Stack>
                )}
              </Box>
              <Divider variant="middle" />
              {loading ? (
                <Stack direction={'column'} sx={{ display: loading ? 'flex' : 'none', }} justifyContent='center' alignItems={'center'} alignContent={'center'}>
                  <Skeleton animation="wave" variant="rounded" height={50} width='80%' sx={{ borderRadius: 6, m: 3, }} />
                </Stack>
              ) : (
                <Box sx={BtnStyle}>
                  {!person['reserved'] ? (
                    <Button variant="contained" sx={BottomBtnStyle}
                      onClick={() => doReservation(person)}>
                      예약하기
                    </Button>
                  ) : (
                    <Button variant="contained" sx={BottomBtnOkStyle}
                      onClick={() => navigate('/MyPage/ReservationView')}>
                      예약확인
                    </Button>
                  )}
                </Box>
              )}
            </Card>
          </Grid>
        )))}
            
      
      
      {
        localStorage.getItem('openConsultationReservation') == 'true'
          ? 
          <Box sx={{px:3, pt:2, mb: 5}}>
            <Stack sx={{ p: 2, bgcolor: '#fff', borderRadius: '20px', mt: 0, }} onClick={() => navigate('../reservationCounsel')}>
              <Stack direction={'row'} alignItems={'center'} spacing={2} >
                    <Box sx={{ bgcolor: '#FEF8F5', width: 64, height: 64, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Avatar alt="" src={counsel} sx={{ borderRadius: 0 }} />
                    </Box>
                      <Stack direction={'column'}>
                        <Typography sx={{ fontSize: 14, color: '#666' }}>심리상담 편리하게 예약하기</Typography>
                        <Typography sx={{ fontSize: 18, fontWeight: 700, m: '5px 0', color: '#555' }}>심리상담 예약</Typography>
                      </Stack>
                </Stack>
            </Stack>
          </Box>
          : ''
      }
      <Bottom />
    </Container>


  );
}

const BtnStyle = {
  display: 'flex',
  justifyContent: 'center',
  m: 3,
};

const BottomBtnStyle = {
  width: '100%',
  bgcolor: '#EF8322',
  fontSize: 18,
  fontWeight: 700,
  borderRadius: '30px', p: 1,
  boxSizing: 'border-box',
  color: '#fff',
  border: '1px solid #ef8322',
  ':hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color: '#fff'
  },
  ':active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  ':focus': {
    boxShadow: 'none',
  },
};

const BottomBtnOkStyle = {
  width: '100%',
  bgcolor: '#2a40d9',
  fontSize: 18,
  fontWeight: 700,
  borderRadius: '30px', p: 1,
  boxSizing: 'border-box',
  color: '#fff',
  border: '1px solid #2a40d9',
  ':hover': {
    backgroundColor: '#2a40d9',
    borderColor: '#2a40d9',
    boxShadow: 'none',
    color: '#fff'
  },
  ':active': {
    boxShadow: 'none',
    backgroundColor: '#2a40d9',
    borderColor: '#2a40d9',
  },
  ':focus': {
    boxShadow: 'none',
  },
};

export default Reservation;